import { Component, ElementRef, ViewChild, inject } from "@angular/core";

import { SvgIconComponent } from "@hermes/aphrodite-svg";
import { UrlUtils } from "@hermes/utils-generic-services-user-interface";

@Component({
    selector: "h-back-to-home-button",
    imports: [SvgIconComponent],
    templateUrl: "./back-to-home-button.component.html",
    styleUrls: ["./back-to-home-button.component.scss"],
})
export class BackToHomeButtonComponent {
    private urlUtils = inject(UrlUtils);

    @ViewChild("backButton")
    public backButton: ElementRef | undefined;

    public goBackToHome(): void {
        this.urlUtils.redirectToRootPath();
    }

    public focus(): void {
        if (this.backButton && this.backButton.nativeElement) {
            this.backButton.nativeElement.focus();
        }
    }
}
